// extracted by mini-css-extract-plugin
export var aircallIframe = "_k6-3";
export var fabContainer = "_k6-5";
export var fabRinging = "_k6-6";
export var loadingOverlay = "_k6-4";
export var pulse = "_k6-7";
export var widgetContent = "_k6-2";
export var widgetPanel = "_k6-0";
export var widgetPanelExpanded = "_k6-1";